import { omit } from 'lodash-es';

const MonoBase = process.env.MONO_BASE;

const getDefaultRequestOpts = (url) => {
  const opts = {
    credentials: 'include',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (url.includes(MonoBase)) {
    // Set owner from value found in global vuex store
    opts.headers['Tgb-Owner'] = window.$vm?.$store?.getters?.owner;
  }

  return opts;
};

export const buildQueryString = (obj = {}) => {
  if (!Object.keys(obj).length) {
    return '';
  }

  return Object.keys(obj)
    .filter((key) => !!obj[key])
    .reduce((memo, key) => `${memo}${key}=${encodeURIComponent(obj[key])}&`, '?')
    .replace(/&$/, ''); // Remove trailing &
};

/**
 * Make an HTTP request using Fetch API.
 * @param {String} url - URL to hit.
 * @param {Object} opts - Additional data to merge into request payload
 * @returns {Object} JSON response from server.
 */
export default async (url, opts = {}) => {
  let query = '';

  if (opts.query) {
    query = buildQueryString(opts.query);
  }

  if (opts.body && typeof opts.body === 'object') {
    opts.body = JSON.stringify(opts.body); // eslint-disable-line no-param-reassign
  }

  const resp = await fetch(url + query, {
    ...getDefaultRequestOpts(url),
    ...omit(opts, ['query']),
  });

  if (!resp.ok) {
    let errorMessage;
    try {
      const data = await resp.json();
      errorMessage = data.error || data.message || 'An unexpected error occurred. Please try again later.';
    } catch (e) {
      errorMessage = 'An unexpected error occurred. Please try again later.';
    }
    const error = new Error(errorMessage);
    error.status = resp.status;
    throw error;
  }

  return resp.status === 204 ? {} : resp.json();
};
